import { useAtomValue } from "jotai";
// import { useCallback, useEffect } from "react";
import { trpc } from "~/lib/trpc";
import { mapEntryAtom } from "~/stores";

export default function useMapAnalytics() {
  const entry = useAtomValue(mapEntryAtom);
  const { mutate } = trpc.analytics.event.useMutation();

  const sendEvent = (name: string, metadata: Record<string, any> = {}) => {
    mutate({
      map_id: entry.id,
      workspace_id: entry.workspace_id,
      name,
      metadata: {
        referrer: document.referrer,
        user_agent: "navigator" in window ? window.navigator.userAgent : "",
        search: window.location.search,
        ...metadata,
      },
    });
  };

  // useEffect(() => {
  //   if (entry) {
  //     sendEvent("pageview");
  //   }
  // }, [entry, sendEvent]);

  return {
    sendEvent,
  };
}
